
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Language } from 'spa-ionata-admin/types';
import langService from 'spa-ionata-admin/lib/services/Languages';
import { loadLanguageAsync, setDebugMode } from '../i18n';
import { settingsModule } from '../store';

@Component({ components: {} })
export default class LangDropdown extends Vue {
  isVisible = false;

  get languages() {
    return langService.languages;
  }

  get currentLanguage(): Language | undefined {
    return langService.langForCode(settingsModule.lang);
  }

  get isDebugMode() {
    return settingsModule.debugMode;
  }

  async selectLanguage(lang: Language) {
    try {
      await loadLanguageAsync(lang.code);
      settingsModule.setCurrentLang(lang);
    } catch (err) {
      console.log('error:', err);
      const message = this.$t('general.unable_to_load_language');
      window.alert(message);
    }
  }

  hide() {
    this.isVisible = false;
  }

  setDebugMode(value: boolean) {
    settingsModule.setDebugMode(value);
    setDebugMode(settingsModule.debugMode);
  }

  dummy() {
    // do nothing
  }

  beforeDestroy() {
    document.removeEventListener('click', this.hide);
  }

  @Watch('isVisible')
  onVisibleChanged() {
    const googleTranslate = document.querySelector(
      '.goog-te-menu-value, .goog-te-gadget-simple',
    ) as HTMLElement;
    if (this.isVisible) {
      document.addEventListener('click', this.hide);
      googleTranslate.click();
    } else {
      document.removeEventListener('click', this.hide);
    }
  }
}
